import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import styled from '@emotion/styled';
import { Header, PartyList,PartyDetail,Paper } from '../components/ContentsComponent';
import { Layout } from '.';

const PostWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 4rem 4rem 1rem 4rem;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    margin: 4rem 2rem 1rem 2rem;
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    margin: 4rem 1rem 1rem 1rem;
  }
`;

const Templates = ({ category,title1,title2,image,headerContent,data,pageContext }) => {
  const Category = category;
  const { edges } = data.allContentfulFood;
  return (
    <Layout>
      <Helmet title={title1} />
      <Header title={title1}>
      {headerContent}
      </Header>
      <PartyDetail image={image} title={title2} />
      <PostWrapper>
        {edges.map(({ node },index) => {
          const { id, Name, path,price,release,tags,text,mainpic,totalCount } = node;
          return (
            <PartyList
              id={`$food-{id}`}
              cover={mainpic.fluid}
              path={path}
              title={Name}
              excerpt={text.json}
              tags={tags}
              price={price}
            />
          );
        })}
      </PostWrapper>
      { Category === "food" && <Paper pageContext={pageContext || []} /> }
    </Layout>
  );
};

export default Templates;

//TODO:category propsからpageContextがrequireか違うかを出力するプログラム
// Templates.propTypes = {
//   category:PropTypes.string.isRequired,
//   title1:PropTypes.string.isRequired,
//   title2:PropTypes.string.isRequired,
//   image:PropTypes.node,
//   headerContent:PropTypes.oneOfType([PropTypes.node,PropTypes.object,PropTypes.string]).isRequired,
//   pageContext:PropTypes.object.isRequired,
//   data: PropTypes.shape({
//     allContentfulFood: PropTypes.shape({
//       edges: PropTypes.arrayOf(
//         PropTypes.shape({
//           node: PropTypes.shape({
//             excerpt: PropTypes.string,
//             frontmatter: PropTypes.shape({
//               cover: PropTypes.object.isRequired,
//               path: PropTypes.string.isRequired,
//               title: PropTypes.string.isRequired,
//               date: PropTypes.string.isRequired,
//               time: PropTypes.string.isRequired,
//               tags: PropTypes.array,
//               wanted: PropTypes.array,
//               price: PropTypes.array.isRequired,
//             }),
//           }),
//         }).isRequired
//       )
//     }),
//   }),
// };
